import React from 'react';
import { SwitchTemplate } from '@catalogo/core-switch-template';
import RenderComponent from '@catalogo/core-render-component';

import Redirect from '@catalogo/core-redirect/src/page';
import Search from '@catalogo/core-search';
import Category from './pages/category';
import Seller from './pages/seller';

const routes = [
  {
    path: '/',
    exact: true,
    type: 'home',
    render: function Component(props) {
      return <RenderComponent Component={SwitchTemplate} component="home" {...props} />;
    },
  },
  {
    path: ['/hotsite/:slug', '/hotsite/:slug/*'],
    exact: true,
    type: 'hotsite',
    render: function Component(props) {
      return <RenderComponent Component={SwitchTemplate} component="hotsite" {...props} />;
    },
  },
  {
    path: '/ofertasdatv',
    exact: true,
    type: 'mediacenter',
    render: function Component(props) {
      return <RenderComponent Component={SwitchTemplate} component="tv-offers" {...props} />;
    },
  },
  {
    path: ['/especial/:slug', '/especial/:slug/*'],
    exact: true,
    type: 'especial',
    render: function Component(props) {
      return <RenderComponent Component={SwitchTemplate} component="hotsite" {...props} />;
    },
  },
  {
    path: ['/landingpage/:slug', '/landingpage/:slug/*'],
    exact: true,
    type: 'landingpage',
    render: function Component(props) {
      return <RenderComponent Component={SwitchTemplate} component="hotsite" {...props} />;
    },
  },
  {
    path: '/oferta-do-dia',
    exact: true,
    type: 'especial',
    render: function Component(props) {
      return <RenderComponent Component={SwitchTemplate} component="hotsite" {...props} />;
    },
  },
  {
    path: ['/lojista/:seller', '/lojista/:seller/*'],
    exact: true,
    type: 'lojista',
    render: function Component(props) {
      return <Redirect {...props} Component={Seller} source="blancalojista" />;
    },
  },
  {
    path: '/busca/:term?',
    type: 'search',
    exact: true,
    render: function Component(props) {
      return <Redirect {...props} Component={Search} />;
    },
  },
  {
    exact: true,
    path: ['/produto/:id', '/produto/:id/:productName'],
    type: 'product',
    render: function Component(props) {
      return <RenderComponent Component={SwitchTemplate} component="product" {...props} />;
    },
  },
  {
    path: '/denuncie/:id/:status?',
    exact: true,
    type: 'report',
    render: function Component(props) {
      return <RenderComponent Component={SwitchTemplate} component="report" {...props} />;
    },
  },
  {
    path: '/newsletter/:tag',
    exact: true,
    type: 'newsletter',
    render: function Component(props) {
      return <RenderComponent Component={SwitchTemplate} component="newsletter" {...props} />;
    },
  },
  {
    path: '/mercado',
    exact: true,
    type: 'market-now',
    render: function Component(props) {
      return <RenderComponent Component={SwitchTemplate} component="mercado" {...props} />;
    },
  },
  {
    path: '/lojas-proximas',
    exact: true,
    type: 'store-list',
    render: function Component(props) {
      return <RenderComponent Component={SwitchTemplate} component="store-list" {...props} />;
    },
  },
  {
    path: '/lojas-proximas/:sellerId/:sellerStoreId/:deliveryType?',
    exact: true,
    type: 'store-offers',
    render: function Component(props) {
      return <RenderComponent Component={SwitchTemplate} component="store-offers" {...props} />;
    },
  },
  {
    path: ['/avaliacao/:id', '/avaliacao/:id/:productName'],
    exact: true,
    type: 'review',
    render: function Component(props) {
      return <RenderComponent Component={SwitchTemplate} component="review" {...props} />;
    },
  },
  {
    path: '/perguntar/:id',
    exact: true,
    type: 'question',
    render: function Component(props) {
      return <RenderComponent Component={SwitchTemplate} component="question" {...props} />;
    },
  },
  {
    path: '/lojas-proximas/busca',
    exact: true,
    type: 'open-store-search',
    render: function Component(props) {
      return <RenderComponent Component={SwitchTemplate} component="open-store-search" {...props} />;
    },
  },
  {
    path: '/listas/favoritos',
    exact: true,
    type: 'wishlist',
    render: function Component(props) {
      return <RenderComponent Component={SwitchTemplate} component="wishlist" {...props} />;
    },
  },
  {
    path: '/perguntar/:id',
    exact: true,
    type: 'questions-and-answers',
    render: function Component(props) {
      return <RenderComponent Component={SwitchTemplate} component="questions-and-answers" {...props} />;
    },
  },
  {
    path: '/garantia/:productId',
    exact: true,
    type: 'services',
    render: function Component(props) {
      return <RenderComponent Component={SwitchTemplate} component="warranty" {...props} />;
    },
  },
  {
    path: ['/categoria/:category', '/categoria/:category/*'],
    exact: true,
    type: 'category',
    render: function Component(props) {
      return <Redirect {...props} Component={Category} source="blanca" />;
    },
  },
  {
    path: ['/marca/:brand', '/marca/:brand/*'],
    exact: true,
    type: 'brand',
    render: function Component(props) {
      return <RenderComponent Component={SwitchTemplate} component="brand" {...props} />;
    },
  },
  {
    path: '/parceiros/:productId',
    exact: true,
    type: 'other_offers',
    render: function Component(props) {
      return <RenderComponent Component={SwitchTemplate} component="other-offers" {...props} />;
    },
  },
  {
    path: '/webpush-teste',
    exact: true,
    type: 'webpush-teste',
    render: function Component(props) {
      return <SwitchTemplate component="webpush-teste" {...props} />;
    },
  },
  {
    path: ['/mapa-do-site', '/mapa-do-site/:type'],
    exact: true,
    type: 'sitemap',
    render: function Component(props) {
      return <RenderComponent Component={SwitchTemplate} component="sitemap" {...props} />;
    },
  },
  {
    path: ['/autor/:autor/*', '/autor/:autor'],
    exact: true,
    type: 'author',
    render: function Component(props) {
      return <RenderComponent Component={SwitchTemplate} component="author" {...props} />;
    },
  },
  {
    path: '/*',
    exact: true,
    render: function Component(props) {
      return <Redirect {...props} />;
    },
  },
];

export default routes;
